module.exports = __webpack_public_path__ + "923011d9a6acab9cb8fe0743ba5e8553.svg";